/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_Project_Mode_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose project mode" |
*
* @param {Form_Start_Chat_Project_Mode_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_project_mode_placeholder = /** @type {((inputs?: Form_Start_Chat_Project_Mode_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_Project_Mode_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle den Projektmodus")
	return /** @type {LocalizedString} */ ("Choose project mode")
});